import * as React from 'react';
import * as author from "./style.module.scss";

export const Author = () => {
  return (
    <section className={author.author}>
      <div className="container">
        <div className={author.author__wrapper}>
          <div className={author.author__image}>
            <img
              src="https://fs.advance.ru/landing-pages/online/kak_nauchit_rebenka_chitat_2/vecherina.png"
              alt={""}
            />
          </div>
          <div className={author.author__title}>
            <h3>Автор и ведущая курса:</h3>
            <h4>Наталья Сергеевна Вечерина</h4>
          </div>
          <div className={author.author__description}>
            <p>Преподаватель высшей категории, ведущий специалист Advance по обучению детей эффективному чтению,
              разработчик курсов и учебников Advance по технологиям обучения, практикующий педагог.</p>
          </div>
        </div>
      </div>
    </section>
  );
};
